type SignatureWithCredentialsArgs = {
  credentialFallback?: string;
  credentials?: Nullable<string>;
  name: string;
};

export function nameWithCredentials({
  credentialFallback,
  credentials,
  name,
}: SignatureWithCredentialsArgs) {
  const resolved = credentials ?? credentialFallback;

  return resolved ? `${name}, ${resolved}` : name;
}
